function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 8,
  fill: "#EEF5FF"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M15.8335 26.6667L19.1668 13.3334M20.8335 26.6667L24.1668 13.3334M15.0002 17.5H26.6668M13.3335 22.5H25.0002",
  stroke: "#365DE6",
  strokeWidth: 1.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgChannelHashtag = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChannelHashtag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/channel-hashtag.f2d84b1e.svg";
export { ForwardRef as ReactComponent };